import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher: React.FC = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button type="button" className="lang-btn" onClick={toggleLanguage}>
      {language === 'en' ? 'Svenska' : 'English'}
    </button>
  );
};

export default LanguageSwitcher;
